// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___23zFO","headerBackBtn":"style__headerBackBtn___k3y6k","headerBackBtn_memorial":"style__headerBackBtn_memorial___3RWPo","image":"style__image___2PgSM","doneControlsContainer":"style__doneControlsContainer___2Y-r0","doneControls":"style__doneControls___1jdYc"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/stickers/ui/screens/new-sticker-media-photo/style.css
// module id = 1329
// module chunks = 0